import { __assign } from "tslib";
import { createTeamApi, defaultGroupSettings } from './index';
import { createHttpTestKit } from '../http/test-kit';
import { UserType } from '../domain';
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder, createFakeDeleteResponder, isWildcard, } from '../test-utils';
import { createSimpleCustomFieldsApiTestKitHandler } from '../custom-fields';
export var createTeamApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createTeamApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetActiveAgents: function (dto) {
            var sortType = dto.sortType ? { agentSortType: dto.sortType } : {};
            return createFakePostResponder(fakeHttp, '/agents/search')(__assign(__assign(__assign({}, dto), sortType), { pageSize: dto.pageSize || 200, userTypes: [UserType.AUTHENTICATED] }));
        },
        whenGetPendingAgents: function (dto) {
            var sortType = dto.sortType ? { agentSortType: dto.sortType } : {};
            return createFakePostResponder(fakeHttp, '/agents/search')(__assign(__assign(__assign({}, dto), sortType), { pageSize: dto.pageSize || 200, userTypes: [UserType.PENDING] }));
        },
        whenGetAllGroups: function () {
            return createFakeGetResponder(fakeHttp, '/groups');
        },
        whenGetGroupMembers: function (dto) {
            var sortType = dto.sortType ? { agentSortType: dto.sortType } : {};
            return createFakePostResponder(fakeHttp, '/agents/search')(__assign(__assign({}, sortType), { pageSize: dto.pageSize || 200, groupIds: [dto.groupId] }));
        },
        whenSetAgentPermission: function (dto) {
            return createFakePutResponder(fakeHttp, "/agents/".concat(dto.agentId, "/permissions"))({ permissionLevel: dto.permissionLevel, roleId: dto.roleId });
        },
        whenRemoveAgent: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/agents/".concat(dto.agentId, "/permissions"));
        },
        whenRemoveAgentFromGroup: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/groups/".concat(dto.groupId, "/members/").concat(dto.agentId));
        },
        whenAddAgentFromGroup: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/groups/".concat(dto.groupId, "/members/").concat(dto.agentId));
        },
        whenAddGroup: function (dto) {
            return createFakePostResponder(fakeHttp, '/groups')(__assign(__assign({}, dto), { settings: dto.settings || defaultGroupSettings }));
        },
        whenEditGroup: function (dto) {
            return createFakePutResponder(fakeHttp, "/groups/".concat(dto.groupId))(__assign(__assign({}, dto), { settings: dto.settings || defaultGroupSettings }));
        },
        whenEditGroupsMembers: function (dto) {
            return createFakePostResponder(fakeHttp, "/groups/memebers")(dto);
        },
        whenDeleteGroup: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/groups/".concat(dto.groupId));
        },
        whenInviteMember: function (dto) {
            return createFakePostResponder(fakeHttp, "/agents/invite")(dto);
        },
        whenRevokeInvitation: function (dto) {
            return createFakePostResponder(fakeHttp, "/agents/".concat(dto.agentId, "/revoke-invitation"))({});
        },
        whenSetAgentLocation: function (dto) {
            return createFakePostResponder(fakeHttp, "/agents/".concat(dto.id, "/data"))({ location: dto.location });
        },
        whenSetAgentChannel: function (dto) {
            return createFakePostResponder(fakeHttp, "/agents/channel")(dto);
        },
        whenSetAgentsChannel: function (dto) {
            return createFakePostResponder(fakeHttp, "/agents/channels")(dto);
        },
        whenSetAgentsChannels: function (dto) {
            return createFakePostResponder(fakeHttp, "/agents/features")(dto);
        },
        whenSetAgentsMaxWorkloads: function (dto) {
            return createFakePostResponder(fakeHttp, "/agents/features/workloads")(dto);
        },
        whenSetAgentStatus: function (dto) {
            return createFakePostResponder(fakeHttp, "/agents/status")(dto);
        },
        whenSetAgentStatusNew: function (dto) {
            return createFakePostResponder(fakeHttp, "/agents/status/new")(dto);
        },
        whenSetAgentStatusOnBehalf: function (dto) {
            return createFakePostResponder(fakeHttp, "/agents/status/new/onBehalf")(dto);
        },
        whenGetCurrentAgent: function () {
            return createFakeGetResponder(fakeHttp, "/agents/me");
        },
        whenGetTeams: function () {
            return createFakeGetResponder(fakeHttp, '/teams');
        },
        whenGetTeam: function (dto) {
            return createFakeGetResponder(fakeHttp, "/teams/".concat(isWildcard(dto) ? '' : dto.id));
        },
        whenUpdateTeams: function (dto) {
            return createFakePutResponder(fakeHttp, "/teams")(dto);
        },
        whenGetLocations: function () { return createFakeGetResponder(fakeHttp, "/locations"); },
        whenGetLocation: function (dto) { return createFakeGetResponder(fakeHttp, "/locations/".concat(isWildcard(dto) ? '' : dto.id)); },
        whenGetAgent: function (agentId) { return createFakeGetResponder(fakeHttp, "/agents/".concat(agentId)); },
        whenUpdateLocations: function (dto) {
            return createFakePutResponder(fakeHttp, "/locations")(dto);
        },
        whenSetAgentDataField: function (dto) { return createFakePutResponder(fakeHttp, "/agents/".concat(isWildcard(dto) ? '' : dto.userId, "/").concat(isWildcard(dto) ? '' : dto.agentDataField))(dto); },
        whenRemoveAgentDataField: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/agents/".concat(isWildcard(dto) ? '' : dto.userId, "/").concat(isWildcard(dto) ? '' : dto.agentDataField));
        },
        whenUpdateAgentCustomFields: function (dto) {
            return createFakePutResponder(fakeHttp, "/agents/".concat(isWildcard(dto) ? '' : dto.id, "/fields"))(dto);
        },
        whenEndAgentSessions: function (id) {
            return createFakePostResponder(fakeHttp, "/agents/".concat(id, "/handling/end"))({});
        },
        whenSetAgentInterfaceLocale: function (dto) { return createFakePutResponder(fakeHttp, "/agents/me/interfaceLocale")(dto); },
        whenCustomFields: createSimpleCustomFieldsApiTestKitHandler('/agents', fakeHttp),
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=teskit.js.map